import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  items: [],
};

export const incensesSlice = createSlice({
  name: "incenses",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sagaActions.INCENSES_LOAD, (state, action) => {
      state.items = action.data.sort((a, b) => b.sale - a.sale);
    });
  },
});

export default incensesSlice.reducer;
